import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from './base.service';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { forkJoin, Subject } from 'rxjs';
import { PrincipalService } from './principal.service';
import { SessionStorageService } from 'ngx-webstorage';
import { map } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class AuthService extends BaseService {
    /*********************Properties*********************/
    signedOut$: Subject<any> = new Subject();
    /*********************Properties*********************/

    /*********************Constructor*********************/
    constructor(
        protected http: HttpClient,
        private cache: CacheResolverService,
        private principal: PrincipalService,
        private storage: SessionStorageService
    ) {
        super(http);
    }
    //apiUrl: any = 'https://arcos-report-dev.apps.cf.np.gc.cahcloud.net/api/';

    authorize() {
        //       return this.principal
        //       .identity().pip;
        const isAuthenticated = this.storage.retrieve(CacheConstant.SessionStorageData.AuthenticationToken);
        if (isAuthenticated) {
            return new Promise((resolve, reject) => {
                resolve(true);
            });
        } else {
            return new Promise((resolve, reject) => {
                const accounts = this.principal.identity(null, true);
                const requests: any = forkJoin(accounts);
                requests.subscribe((response: IResponse[]) => {

                    resolve(true);
                });
            });
        }


    }

    logOut(logoutMethod: string = 'timeout') {
        let authAccessToken = this.storage.retrieve(CacheConstant.SessionStorageData.AuthAccessToken);
        let userId: any = '';
        let userEmail: any = '';
        if (authAccessToken) {
            let decoded: any = jwt_decode(authAccessToken);
            userId = JSON.parse(JSON.stringify(decoded.user_claims).replace(/\\/g, '').slice(1, -1)).id.toString();
            userEmail = JSON.parse(JSON.stringify(decoded.userinfo).replace(/\\/g, '').slice(1, -1)).email;
        }
       
      this.getEnivronment(logoutMethod, userId, userEmail);
    }

    getEnivronment(logoutMethod, userId, userEmail) {
       this.principal.getLogoutEnvironment(logoutMethod, userId, userEmail).subscribe({
            next: (response: IResponse) => {
                const url = response?.data?.value;
                this.handleLogoutRedirect(url || '/login');
            },
            error: () => {
                this.principal.getEnvironment('logouturl').subscribe({
                    next: (response: IResponse) => {
                        const baseUrl = response?.data?.value;
                        this.handleLogoutRedirect(baseUrl ? baseUrl + '/logout' : '/login');
                    },
                    error: () => {
                        this.handleLogoutRedirect('/login');
                    }
                });
            }
        });


    }

    private handleLogoutRedirect(url: string) {
        this.signedOut$.next(true);
        this.reset();
        window.location.href = url;
    }

    woRedirect(authToken) {
        let accessToken = this.storage.retrieve(CacheConstant.SessionStorageData.AccessToken);
        let idToken = this.storage.retrieve(CacheConstant.SessionStorageData.IdToken);
        let refreshToken = this.storage.retrieve(CacheConstant.SessionStorageData.RefreshToken);
        let tokenInfo = '?ACCESS_TOKEN=' + accessToken + '&AUTH_TOKEN=' + authToken + '&ID_TOKEN=' + idToken + '&REFRESH_TOKEN=' + refreshToken;
        this.reset();

        this.redirectTo('wourl', tokenInfo);
    }

    redirectTo(env, queryParams) {
        this.principal.getEnvironment(env).subscribe((response: IResponse) => {
            let url = response.data.value;
            if (queryParams) {
                url = url.concat(queryParams);
            }
            window.location.href = (env == "logouturl") ? url + "/logout" : url; //Okta
        });

    }

    reset() {
        //clear session
        this.storage.clear();
        this.resetCache();
    }

    resetCache() {
        this.cache.remove(CacheConstant.LocalStorage.ActiveUsersList);
        this.cache.remove(CacheConstant.LocalStorage.reservations);;
        this.cache.remove(CacheConstant.LocalStorage.Mobile);
        this.cache.remove(CacheConstant.LocalStorage.DeliveryAddress);
        this.cache.remove(CacheConstant.LocalStorage.Preferences);
        this.cache.remove('procedures');
        this.cache.remove(CacheConstant.LocalStorage.SpecialProducts);
        this.cache.remove(CacheConstant.LocalStorage.Uoms);
        this.cache.remove('currDate');
        this.cache.remove('selectedTask');
        this.cache.remove(CacheConstant.LocalStorage.Specialitydata);
        this.cache.remove(CacheConstant.LocalStorage.Preferences);
        this.cache.remove(CacheConstant.LocalStorage.RefreshTokenCounter);
        this.cache.remove('Identity');
        this.cache.remove('Authenticated');
    }

    authorizeOverride(userId: any, password: any, permission: any, wdFlag = false) {
        let data: any;
        const url = this.apiConfig.util + '/api/auth/authenticate'
        if (wdFlag) {
            data = {userId:userId,password:password,permission:permission, isTheranosticsWd: true};
        } else {
            data = { userId: userId, password: password, permission: permission };
        }
        return super.post(url, data).pipe(
            map((response: HttpResponse<any>) => {
                let res: any = response;
                if (!res.hasError) {
                    return { status: true, invalid: false, accessDenied: false }
                } else {
                    if (res.error.status == 403) {
                        return { status: false, invalid: res.error.error.invalid, accessDenied: res.error.error.accessDenied }
                    } else {
                        return { status: false, invalid: false, accessDenied: false }
                    }
                }
            })
        );

        // .then(function(response){
        // 		return {status:true,invalid:false,accessDenied:false}
        // 	},function(response) {
        // 		return response.status == 403 ?  {status:false,invalid:response.data.invalid,accessDenied:response.data.accessDenied}
        // 			: {status:false,invalid:false,accessDenied:false}
        // 	});
    }

    // redirectTo(env, queryParams) {
    //     Environment.get(env).then(function(url) {
    //         if (queryParams) {
    //             url = url.concat(queryParams);
    //         }
    //         window.location.href = (env == "logouturl") ? url + "/logout" : url; //Okta
    //     });
    // }
}
